/** Paths that guests can browse without signing in. */
const PUBLIC_EXACT = new Set(["/", "/login", "/admin/login", "/team-lunch", "/book"]);

export function isPublicPath(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  if (PUBLIC_EXACT.has(path)) return true;
  if (path.startsWith("/caregivers/")) return true;
  if (path.startsWith("/book")) return true;
  return false;
}

export function isAdminPath(pathname = "") {
  const path = String(pathname || "").split("?")[0];
  return path === "/admin" || path.startsWith("/admin/");
}

/** Admin console login URL — username + password only (no mobile OTP). */
export function buildAdminLoginPath(returnTo = "/admin") {
  const params = new URLSearchParams();
  const path = String(returnTo || "").split("?")[0].trim();
  if (path && isAdminPath(path) && path !== "/admin/login") {
    params.set("returnTo", path);
  }
  const qs = params.toString();
  return qs ? `/admin/login?${qs}` : "/admin/login";
}

export function loginPathForContext(pathname = "") {
  if (isAdminPath(pathname)) {
    return buildAdminLoginPath(pathname);
  }
  return "/";
}

export function isOpsAuthRole(role) {
  const normalized = String(role || "").trim().toUpperCase();
  return normalized === "ADMIN" || normalized === "OPS";
}

export const POST_LOGOUT_PATH = "/";
